// extracted by mini-css-extract-plugin
export default {"container":"ErrorComponent_container__rmeRL","icon":"ErrorComponent_icon__hp6Am","info":"ErrorComponent_info__LdTb3"};